import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import { Dropdown } from 'semantic-ui-react';
import { getstg, setstg, virtkbd } from '../../../utils';
import * as API from '../../API';
import './KbMunicipalitySelector.scss';
export const KbMunicipalitySelector = ({ className, preventDefault, clearable = false, stayInFocus, scrollTop = true, onSelect, onClick, prompt, value, pathTemplate = '#kommuner/{kommune_knr}' }) => {
    var _a, _b, _c, _d;
    // Construct regular expression from pathTemplate to extract current field value
    const fieldName = (_b = (_a = pathTemplate.match(/\{([^}]+)\}/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : 'kommune_knr';
    const fieldKey = fieldName;
    const pattern = `${pathTemplate.replace(`{${fieldName}}`, '(\\d{4})')}`;
    const r = new RegExp(pattern);
    let currentSelection = value !== null && value !== void 0 ? value : ((_d = (_c = window.location.hash.match(r)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : null);
    const { data: municipalityListData } = useQuery('kb/kommuner', () => API.fetchMunicipalityList());
    const municipalityList = Object.entries(municipalityListData !== null && municipalityListData !== void 0 ? municipalityListData : {}).map(([kommune_knr, item]) => ({
        key: kommune_knr,
        value: item.kommune_knr,
        text: `${item.kommune_knr} ${item.kommune_navn}`,
    }));
    const onSelectMunicipality = (event, data) => {
        const currentMunicipality = municipalityListData === null || municipalityListData === void 0 ? void 0 : municipalityListData[data.value];
        if (currentMunicipality === null || currentMunicipality === void 0 ? void 0 : currentMunicipality.kommune_knr) {
            const stg = getstg();
            if (stg.preferences) {
                stg.preferences.favorite = currentMunicipality.kommune_knr;
            }
            else {
                stg.preferences = {
                    favorite: currentMunicipality.kommune_knr
                };
            }
            setstg(stg);
        }
        if (!preventDefault) {
            if (currentMunicipality) {
                let locHash = pathTemplate.replace(`{${fieldName}}`, currentMunicipality[fieldKey]);
                if (scrollTop === false) {
                    locHash += "?noscroll";
                }
                window.location.hash = locHash;
            }
            else {
            }
            if (!stayInFocus || virtkbd()) {
                requestAnimationFrame(() => {
                    document.querySelector('.kb-labfront .kb-municipality-selector').focus();
                });
            }
        }
        if (onSelect) {
            onSelect(currentMunicipality);
        }
    };
    const clsx = [
        'kb-selector',
        'page-element kb-municipality-selector',
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    return (_jsx("div", { className: clsx, tabIndex: -1, children: _jsx(Dropdown, { placeholder: prompt !== null && prompt !== void 0 ? prompt : "Søk etter kommune", fluid: true, search: true, selection: true, clearable: clearable, value: currentSelection !== null && currentSelection !== void 0 ? currentSelection : '', options: municipalityList, onChange: onSelectMunicipality, onClick: onClick }) }));
};
